(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- Hero carousel ----------
  var hero = document.querySelector('.hero');
  var slides = Array.prototype.slice.call(document.querySelectorAll('.hero__slide'));
  var prev = document.querySelector('.hero__arrow--prev');
  var next = document.querySelector('.hero__arrow--next');
  if (hero && slides.length > 1 && prev && next) {
    var current = 0, timer = null, paused = false;
    var show = function (i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var active = n === current;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    };
    var stop = function () { clearInterval(timer); timer = null; };
    var start = function () {
      stop();
      if (reduceMotion || paused) return;
      timer = setInterval(function () { show(current + 1); }, 6000);
    };
    prev.addEventListener('click', function () { show(current - 1); start(); });
    next.addEventListener('click', function () { show(current + 1); start(); });
    hero.addEventListener('mouseenter', function () { paused = true; stop(); });
    hero.addEventListener('mouseleave', function () { paused = false; start(); });
    hero.addEventListener('focusin', function () { paused = true; stop(); });
    hero.addEventListener('focusout', function () { paused = false; start(); });
    hero.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(current - 1); start(); }
      if (e.key === 'ArrowRight') { show(current + 1); start(); }
    });
    // Touch swipe
    var startX = null;
    hero.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) { show(current + (dx < 0 ? 1 : -1)); start(); }
      startX = null;
    }, { passive: true });
    // Pause when tab hidden
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    show(0);
    start();
  }

  // ---------- Mobile menu + tap-to-open submenus ----------
  var burger = document.querySelector('.burger');
  var nav = document.getElementById('mainnav');
  var mobile = window.matchMedia('(max-width: 1100px)');

  var closeMenu = function () {
    if (!nav || !burger) return;
    nav.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Open menu');
    document.querySelectorAll('.has-sub.is-open').forEach(function (li) {
      li.classList.remove('is-open');
      var a = li.querySelector(':scope > a');
      if (a) a.setAttribute('aria-expanded', 'false');
    });
  };

  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(open));
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) { closeMenu(); burger.focus(); }
    });
  }

  document.querySelectorAll('.has-sub > a').forEach(function (a) {
    a.setAttribute('aria-haspopup', 'true');
    a.setAttribute('aria-expanded', 'false');
    a.addEventListener('click', function (e) {
      if (mobile.matches) {
        e.preventDefault();
        var open = a.parentElement.classList.toggle('is-open');
        a.setAttribute('aria-expanded', String(open));
      }
    });
    // Keyboard: Enter/Space/ArrowDown opens on desktop
    a.addEventListener('keydown', function (e) {
      if (!mobile.matches && (e.key === 'ArrowDown')) {
        e.preventDefault();
        var first = a.parentElement.querySelector('.sub a');
        if (first) first.focus();
      }
    });
    a.parentElement.addEventListener('focusin', function () { if (!mobile.matches) a.setAttribute('aria-expanded', 'true'); });
    a.parentElement.addEventListener('focusout', function (e) {
      if (!mobile.matches && !a.parentElement.contains(e.relatedTarget)) a.setAttribute('aria-expanded', 'false');
    });
  });

  var onBreakpoint = function () { if (!mobile.matches) closeMenu(); };
  if (mobile.addEventListener) { mobile.addEventListener('change', onBreakpoint); } else { mobile.addListener(onBreakpoint); }

  // ---------- Product gallery thumbnails ----------
  var main = document.querySelector('[data-gallery-main]');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!main) return;
      main.src = btn.getAttribute('data-src');
      main.srcset = btn.getAttribute('data-srcset') || '';
      main.alt = btn.getAttribute('data-alt') || '';
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-current', 'false'); });
      btn.classList.add('is-active');
      btn.setAttribute('aria-current', 'true');
    });
  });

  // ---------- Scroll reveal ----------
  var revealEls = document.querySelectorAll('.block, .perks, .newsletter');
  if (!reduceMotion && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('js-reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    revealEls.forEach(function (el) { io.observe(el); });
  }
})();

// ---------- Theme toggle, cart drawer, sticky CTA ----------
(function () {
  var root = document.documentElement;
  var isShopify = !!(window.Shopify && window.Shopify.routes);
  var base = isShopify ? window.Shopify.routes.root : '/';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  // ----- Theme toggle (light by default; choice is remembered) -----
  var toggles = document.querySelectorAll('[data-theme-toggle]');
  function currentTheme() { return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light'; }
  function paintToggle() {
    var dark = currentTheme() === 'dark';
    toggles.forEach(function (b) { b.setAttribute('aria-label', dark ? 'Switch to light theme' : 'Switch to dark theme'); b.setAttribute('aria-pressed', String(dark)); });
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', dark ? '#0b0f12' : '#2f9bbd');
  }
  toggles.forEach(function (b) {
    b.addEventListener('click', function () {
      var next = currentTheme() === 'dark' ? 'light' : 'dark';
      if (next === 'dark') root.setAttribute('data-theme', 'dark'); else root.removeAttribute('data-theme');
      try { localStorage.setItem('theme', next); } catch (e) {}
      paintToggle();
    });
  });
  paintToggle();

  // ----- Toast -----
  var toast = document.querySelector('[data-toast]'), toastTimer;
  function say(msg) {
    if (!toast) return;
    toast.textContent = msg; toast.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 2600);
  }

  // ----- Cart drawer -----
  var drawer = document.getElementById('cart-drawer');
  var backdrop = document.querySelector('[data-drawer-backdrop]');
  var itemsEl = document.querySelector('[data-drawer-items]');
  var totalEl = document.querySelector('[data-drawer-total]');
  var checkout = document.querySelector('[data-checkout]');
  var lastFocus = null;

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function render(cart) {
    if (!itemsEl) return;
    var items = (cart && cart.items) || [];
    setCount((cart && cart.item_count) || 0);
    if (totalEl) totalEl.textContent = money((cart && cart.total_price) || 0);
    if (checkout) {
      checkout.setAttribute('href', isShopify ? base + 'checkout' : '#');
      checkout.style.display = items.length ? '' : 'none';
    }
    if (!items.length) {
      itemsEl.innerHTML = '<p class="drawer__empty">Your cart is empty.<br><a class="btn btn--sm" style="margin-top:14px" href="' + (isShopify ? base + 'collections/custom-tshirts' : 'https://www.designzbynoah.com/collections/custom-tshirts') + '" data-cart-close>Customize Your Shirt</a></p>';
      return;
    }
    itemsEl.innerHTML = items.map(function (it, i) {
      var img = it.image ? '<img src="' + esc(it.image) + '" alt="" width="64" height="64" loading="lazy">' : '<span></span>';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<p>' + esc(it.variant_title) + '</p>' : '';
      return '<div class="drawer__item">' + img +
        '<div><h3><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></h3>' + variant +
        '<div class="drawer__qty"><button type="button" data-qty="' + (i + 1) + ':' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button><span>' + it.quantity +
        '</span><button type="button" data-qty="' + (i + 1) + ':' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div></div>' +
        '<strong>' + money(it.final_line_price) + '</strong></div>';
    }).join('');
  }
  function refresh() {
    if (!isShopify) { render({ items: [], item_count: 0, total_price: 0 }); return Promise.resolve(); }
    return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(render).catch(function () {});
  }
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.classList.add('is-locked');
    drawer.setAttribute('tabindex', '-1'); drawer.focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    if (!t) return;
    var open = t.closest('[data-cart-open]');
    if (open && drawer) {
      // On Shopify keep the real cart page as a no-JS fallback
      e.preventDefault(); lastFocus = e.detail === 0 ? document.activeElement : null; refresh().then(openDrawer); return;
    }
    if (t.closest('[data-cart-close]') || t.closest('[data-drawer-backdrop]')) { closeDrawer(); return; }
    var q = t.closest('[data-qty]');
    if (q && isShopify) {
      var parts = q.getAttribute('data-qty').split(':');
      fetch(base + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +parts[0], quantity: Math.max(0, +parts[1]) }) })
        .then(function (r) { return r.json(); }).then(render).catch(function () { say('Could not update cart'); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer(); });

  // Ajax add-to-cart (Shopify only): any product form posts to the drawer instead of leaving the page
  if (isShopify) {
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.getAttribute || (f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      e.preventDefault();
      var btn = f.querySelector('[type="submit"]'), label = btn && btn.textContent;
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch(base + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return refresh(); })
        .then(function () { openDrawer(); })
        .catch(function () { f.submit(); })
        .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
    });
  }
  refresh();

  // ----- Sticky mobile CTA -----
  var sticky = document.querySelector('[data-sticky-cta]');
  if (sticky) {
    var ticking = false;
    var update = function () {
      var show = window.scrollY > 520;
      var foot = document.querySelector('.newsletter, .site-footer');
      if (foot && foot.getBoundingClientRect().top < window.innerHeight - 40) show = false;
      sticky.classList.toggle('is-on', show);
      ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  // ----- Marquee: pause on hover/focus -----
  var mq = document.querySelector('.marquee__track');
  if (mq && !reduce) {
    var wrap = mq.parentElement;
    wrap.addEventListener('mouseenter', function () { mq.style.animationPlayState = 'paused'; });
    wrap.addEventListener('mouseleave', function () { mq.style.animationPlayState = ''; });
  }
})();

// ---------- Compact sticky header on phones ----------
(function () {
  var header = document.querySelector('.site-header');
  var search = document.querySelector('.header-top .search');
  var mobile = window.matchMedia('(max-width: 760px)');
  if (!header || !search) return;
  function fit() {
    if (!mobile.matches) { header.style.top = ''; return; }
    var cs = getComputedStyle(search);
    var hide = search.offsetHeight + parseFloat(cs.marginTop || 0) + parseFloat(cs.marginBottom || 0);
    header.style.top = -hide + 'px';
  }
  fit();
  window.addEventListener('resize', fit);
  window.addEventListener('orientationchange', fit);
  window.addEventListener('load', fit);
  if (mobile.addEventListener) mobile.addEventListener('change', fit);
})();

// ---------- Menu parents without a page: open the submenu instead of jumping to top ----------
document.querySelectorAll('.has-sub > a[href="#"], .has-sub > a[data-nolink]').forEach(function (a) {
  a.addEventListener('click', function (e) { e.preventDefault(); });
});

// ---------- Sliding reviews ----------
(function () {
  var box = document.querySelector('[data-reviews]');
  if (!box) return;
  var track = box.querySelector('.reviews__track');
  var prev = box.querySelector('[data-reviews-prev]');
  var next = box.querySelector('[data-reviews-next]');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var timer = null, paused = false;
  function step() {
    var card = track.querySelector('blockquote');
    if (!card) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }
  function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
  function go(dir) {
    if (dir > 0 && atEnd()) { track.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' }); return; }
    if (dir < 0 && track.scrollLeft <= 4) { track.scrollTo({ left: track.scrollWidth, behavior: reduce ? 'auto' : 'smooth' }); return; }
    track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
  }
  function stop() { clearInterval(timer); timer = null; }
  function start() { stop(); if (reduce || paused || track.scrollWidth <= track.clientWidth + 4) return; timer = setInterval(function () { go(1); }, 4500); }
  if (prev) prev.addEventListener('click', function () { go(-1); start(); });
  if (next) next.addEventListener('click', function () { go(1); start(); });
  ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { box.addEventListener(ev, function () { paused = true; stop(); }, { passive: true }); });
  ['mouseleave', 'focusout'].forEach(function (ev) { box.addEventListener(ev, function () { paused = false; start(); }); });
  box.addEventListener('touchend', function () { setTimeout(function () { paused = false; start(); }, 6000); }, { passive: true });
  document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  window.addEventListener('resize', start);
  start();
})();
